import { ReactNode, useState } from 'react'
import {
  getInitialSidebarState,
  persistSidebarState
} from '../util/sidebarState'
import { Footer } from './Footer'
import { AppHeader } from './layout/AppHeader'
import { Sidebar } from './layout/Sidebar'
import { SidebarInset, SidebarProvider } from './ui/sidebar'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(getInitialSidebarState)

  const handleOpenChange = (open: boolean) => {
    setSidebarOpen(open)
    persistSidebarState(open)
  }

  return (
    <SidebarProvider open={sidebarOpen} onOpenChange={handleOpenChange}>
      <Sidebar />
      <SidebarInset>
        <AppHeader />
        <main className="flex-1 overflow-x-auto">
          <div className="p-6">{children}</div>
        </main>
        <Footer />
      </SidebarInset>
    </SidebarProvider>
  )
}
